export const siteName = "华丽的外出";

export const navLinks = [
  { id: "index", num: "01", label: "本页索引" },
  { id: "profile", num: "02", label: "影片速览" },
  { id: "highlights", num: "03", label: "看点卡片" },
  { id: "gallery", num: "04", label: "剧照陈列" },
  { id: "resource", num: "05", label: "资源与网盘" },
  { id: "faq", num: "06", label: "常见答疑" },
];

export const heroCovers = [
  {
    id: 1,
    tag: "画面 · 一",
    title: "金色原野",
    caption: "出走的第一程",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20still%20of%20an%20elegant%20woman%20in%20a%20flowing%20dress%20walking%20through%20a%20vast%20sunlit%20wheat%20field%20at%20golden%20hour%2C%20warm%20amber%20and%20cream%20tones%2C%20soft%20film%20grain%2C%20dreamy%20bokeh%2C%20quiet%20artistic%20mood%2C%20no%20text%2C%20refined%20composition%2C%20high%20detail%2C%20muted%20warm%20color%20grading&width=700&height=1000&seq=glm-cover-a1&orientation=portrait",
  },
  {
    id: 2,
    tag: "画面 · 二",
    title: "窗边黄昏",
    caption: "城市里的停顿",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20still%20of%20a%20woman%20by%20a%20large%20window%20at%20dusk%20reflected%20in%20the%20glass%2C%20warm%20honey%20light%20and%20dusty%20amber%20shadows%2C%20soft%20film%20grain%2C%20melancholic%20quiet%20atmosphere%2C%20elegant%20interior%2C%20no%20text%2C%20refined%20composition%2C%20high%20detail%2C%20muted%20warm%20color%20grading&width=700&height=1000&seq=glm-cover-b2&orientation=portrait",
  },
  {
    id: 3,
    tag: "画面 · 三",
    title: "海线尽头",
    caption: "把背影交给远方",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20still%20of%20a%20lone%20figure%20in%20a%20long%20coat%20standing%20on%20a%20quiet%20shoreline%20at%20sunset%2C%20soft%20golden%20and%20dusty%20cream%20tones%2C%20gentle%20film%20grain%2C%20vast%20calm%20sea%20horizon%2C%20poetic%20lonely%20mood%2C%20no%20text%2C%20refined%20composition%2C%20high%20detail%2C%20muted%20warm%20color%20grading&width=700&height=1000&seq=glm-cover-c3&orientation=portrait",
  },
];

export const indexItems = [
  {
    num: "01",
    title: "完整版在线观看",
    desc: "一条顺畅的播放入口，打开即可观看，不必在多个页面之间来回跳转寻找片段。",
    anchor: "#resource",
    icon: "ri-play-circle-line",
  },
  {
    num: "02",
    title: "未删减高清资源",
    desc: "保留完整时长与全部段落，画质以高清为主，原始构图与色调都尽量维持原貌。",
    anchor: "#resource",
    icon: "ri-hd-line",
  },
  {
    num: "03",
    title: "百度云分享入口",
    desc: "网盘链接与保存方式集中在此处，方便收藏之后随时离线观看，不受网络波动影响。",
    anchor: "#resource",
    icon: "ri-cloud-line",
  },
  {
    num: "04",
    title: "剧照与画面图集",
    desc: "以大图卡片陈列关键场景，先看画面气质，再决定从哪一段开始进入故事。",
    anchor: "#gallery",
    icon: "ri-image-2-line",
  },
  {
    num: "05",
    title: "影迷答疑",
    desc: "关于时长、清晰度、字幕与链接是否失效的常见问题，逐条说明，省去反复询问。",
    anchor: "#faq",
    icon: "ri-question-answer-line",
  },
];

export const profileIntro =
  "《华丽的外出》是一部关于“离开”与“回到自己”的文艺长片。它不急着交代结局，而是把镜头交给路途本身：一段金色的原野、一间黄昏的屋子、一条没有尽头的海线。本页把观看入口、未删减高清资源与百度云分享整理在同一条路径上，让你从画面出发，慢慢进入这段出走。";

export const profileFacts = [
  { label: "影片名称", value: "华丽的外出" },
  { label: "版本形式", value: "完整版 · 未删减" },
  { label: "画质规格", value: "高清 1080P" },
  { label: "影片类型", value: "剧情 / 文艺" },
  { label: "对白语言", value: "普通话" },
  { label: "字幕情况", value: "中文字幕" },
  { label: "整理方式", value: "专题合集 · 逐段索引" },
  { label: "观看方式", value: "在线观看 / 网盘分享" },
];

export const profileImage =
  "https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20an%20empty%20countryside%20road%20at%20golden%20hour%20with%20warm%20sunlight%20and%20long%20shadows%2C%20soft%20amber%20and%20cream%20tones%2C%20gentle%20film%20grain%2C%20poetic%20calm%20atmosphere%2C%20no%20people%2C%20no%20text%2C%20refined%20composition%2C%20high%20detail%2C%20muted%20warm%20color%20grading&width=900&height=620&seq=glm-profile-d4&orientation=landscape";

export const highlights = [
  {
    id: 1,
    kicker: "出发",
    title: "画面语言：从室内走向原野",
    desc: "镜头跟着主角推开门，暖色天光一路铺开。景别由近及远层层递进，画面本身就是叙事的一部分。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20warm%20golden%20morning%20light%20pouring%20across%20an%20open%20field%20seen%20from%20a%20doorway%2C%20amber%20and%20cream%20palette%2C%20soft%20film%20grain%2C%20quiet%20expansive%20mood%2C%20no%20text%2C%20refined%20composition%2C%20high%20detail%2C%20muted%20warm%20color%20grading&width=800&height=520&seq=glm-high-01&orientation=landscape",
  },
  {
    id: 2,
    kicker: "中途",
    title: "配乐与留白：把对白收掉",
    desc: "关键段落刻意减少台词，让音乐与呼吸感承担情绪。节奏慢下来，观众才有空间去感受那些没说出口的话。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20quiet%20dim%20room%20with%20a%20warm%20lamp%20and%20dust%20in%20the%20air%2C%20soft%20amber%20glow%20and%20deep%20cream%20shadows%2C%20gentle%20film%20grain%2C%20intimate%20contemplative%20mood%2C%20no%20text%2C%20refined%20composition%2C%20high%20detail%2C%20muted%20warm%20color%20grading&width=800&height=520&seq=glm-high-02&orientation=landscape",
  },
  {
    id: 3,
    kicker: "转折",
    title: "城市与旷野：两个世界的分身",
    desc: "冷硬的建筑群与辽阔的自然反复对照，人物在两个世界里各有分身，选择也就有了重量。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20contrasting%20distant%20city%20rooftops%20with%20a%20wide%20open%20sunlit%20plain%20beyond%2C%20warm%20terracotta%20and%20cream%20tones%2C%20soft%20film%20grain%2C%20reflective%20mood%2C%20no%20text%2C%20refined%20composition%2C%20high%20detail%2C%20muted%20warm%20color%20grading&width=800&height=520&seq=glm-high-03&orientation=landscape",
  },
  {
    id: 4,
    kicker: "收束",
    title: "开放的结局：留一段长长的空镜",
    desc: "结尾没有给出明确答案，只留下一段安静的空镜，把判断与余味一起交还给观众。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20vast%20empty%20horizon%20at%20the%20end%20of%20the%20day%20with%20soft%20warm%20fading%20light%2C%20amber%20and%20dusty%20cream%20tones%2C%20gentle%20film%20grain%2C%20open%20contemplative%20ending%20mood%2C%20no%20text%2C%20refined%20composition%2C%20high%20detail%2C%20muted%20warm%20color%20grading&width=800&height=520&seq=glm-high-04&orientation=landscape",
  },
];

export const gallery = [
  {
    id: 1,
    caption: "原野上的第一缕光",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20soft%20golden%20light%20over%20a%20quiet%20wheat%20field%2C%20warm%20amber%20and%20cream%20tones%2C%20gentle%20film%20grain%2C%20serene%20poetic%20mood%2C%20no%20text%2C%20refined%20composition%2C%20high%20detail%2C%20muted%20warm%20color%20grading&width=640&height=420&seq=glm-still-01&orientation=landscape",
  },
  {
    id: 2,
    caption: "窗帘被风掀起的一刻",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20light%20linen%20curtain%20lifted%20by%20wind%20in%20a%20warm%20sunlit%20room%2C%20soft%20honey%20tones%2C%20gentle%20film%20grain%2C%20quiet%20nostalgic%20mood%2C%20no%20text%2C%20refined%20composition%2C%20high%20detail%2C%20muted%20warm%20color%20grading&width=640&height=420&seq=glm-still-02&orientation=landscape",
  },
  {
    id: 3,
    caption: "路边小店与旧招牌",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20small%20roadside%20shop%20with%20a%20faded%20wooden%20sign%20at%20dusk%2C%20warm%20amber%20lamp%20glow%20and%20cream%20tones%2C%20soft%20film%20grain%2C%20nostalgic%20quiet%20mood%2C%20no%20text%2C%20refined%20composition%2C%20high%20detail%2C%20muted%20warm%20color%20grading&width=640&height=420&seq=glm-still-03&orientation=landscape",
  },
  {
    id: 4,
    caption: "被夕阳染红的云",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20soft%20clouds%20tinted%20warm%20red%20and%20amber%20at%20sunset%2C%20glowing%20golden%20cream%20tones%2C%20gentle%20film%20grain%2C%20expansive%20calm%20mood%2C%20no%20text%2C%20refined%20composition%2C%20high%20detail%2C%20muted%20warm%20color%20grading&width=640&height=420&seq=glm-still-04&orientation=landscape",
  },
  {
    id: 5,
    caption: "回程路上的空座",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20empty%20seat%20by%20a%20train%20window%20with%20warm%20afternoon%20light%2C%20amber%20and%20cream%20tones%2C%20soft%20film%20grain%2C%20lonely%20reflective%20mood%2C%20no%20text%2C%20refined%20composition%2C%20high%20detail%2C%20muted%20warm%20color%20grading&width=640&height=420&seq=glm-still-05&orientation=landscape",
  },
  {
    id: 6,
    caption: "海线尽头的那道光",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20calm%20sea%20horizon%20with%20a%20warm%20band%20of%20light%20at%20dusk%2C%20golden%20and%20dusty%20cream%20tones%2C%20gentle%20film%20grain%2C%20vast%20peaceful%20mood%2C%20no%20text%2C%20refined%20composition%2C%20high%20detail%2C%20muted%20warm%20color%20grading&width=640&height=420&seq=glm-still-06&orientation=landscape",
  },
];

export const resources = [
  {
    id: 1,
    icon: "ri-play-circle-line",
    title: "完整版在线观看",
    desc: "点击即可进入播放页，完整时长、不跳段，画质以高清为主，适合先看一遍再决定是否保存。",
    meta: ["高清 1080P", "中文字幕", "完整未删减"],
    action: "立即播放",
    badge: "推荐",
  },
  {
    id: 2,
    icon: "ri-download-2-line",
    title: "未删减高清资源",
    desc: "收录完整段落与全部画面，文件为高清版本，保留原始构图与色调，方便收藏后反复回看。",
    meta: ["未删减", "1080P", "普通话原声"],
    action: "查看资源",
    badge: "会保留全部段落",
  },
  {
    id: 3,
    icon: "ri-cloud-line",
    title: "百度云网盘分享",
    desc: "网盘链接与提取方式集中整理在此，保存到自己的网盘后可随时离线观看，不受播放页限制。",
    meta: ["百度云", "可离线", "长期保存"],
    action: "获取分享链接",
    badge: "离线观看",
  },
];

export const faqs = [
  {
    id: 1,
    q: "《华丽的外出》完整版在哪里可以看？",
    a: "本页顶部与“资源与网盘”区域都提供了完整版在线观看的入口，点击“立即播放”即可进入播放页，无需在多个站点之间反复查找片段。",
  },
  {
    id: 2,
    q: "未删减版和普通版本有什么区别？",
    a: "未删减高清资源保留完整时长与全部段落，画面没有额外剪裁，原始构图与色调也会尽量维持原貌，观感更接近影片本身的节奏。",
  },
  {
    id: 3,
    q: "高清资源的画质和字幕怎么样？",
    a: "整理的高清资源以 1080P 为主，包含中文字幕与普通话原声。若你对清晰度要求更高，可以优先选择网盘中的高清文件保存后观看。",
  },
  {
    id: 4,
    q: "百度云网盘链接失效了怎么办？",
    a: "网盘分享偶尔会因过期或转存次数过多而失效。若遇到打不开的情况，可以先回到本页查看是否已更新链接，通常会在原位置替换为可用的新分享。",
  },
  {
    id: 5,
    q: "观看需要注册或登录吗？",
    a: "不需要。在线观看入口与百度云分享都以直接打开为主，无需注册或登录账号，打开页面即可进入观看流程。",
  },
];

export const footerGroups = [
  {
    title: "本页导航",
    links: [
      { label: "本页索引", anchor: "#index" },
      { label: "影片速览", anchor: "#profile" },
      { label: "看点卡片", anchor: "#highlights" },
      { label: "剧照陈列", anchor: "#gallery" },
    ],
  },
  {
    title: "观看资源",
    links: [
      { label: "完整版在线观看", anchor: "#resource" },
      { label: "未删减高清资源", anchor: "#resource" },
      { label: "百度云网盘分享", anchor: "#resource" },
      { label: "常见答疑", anchor: "#faq" },
    ],
  },
];